<template>
  <div id="directors">
    <app-menu></app-menu>
    <admin-list-component
        :title="'Admin.menu.directors' | staticTranslation"
        :add-text="'Admin.components.addDirector' | staticTranslation"
        edit-path="/admin/program/director/edit/"
        entity-name="director"
        :get-name-function="getName"
        draggable="true"
    />
  </div>
</template>

<script>
import AdminMenu from "@/components/admin/AdminMenu";
import AdminListComponent from "@/components/admin/AdminListComponent";

export default {
  name: "ProgramDirector",
  components: {
    'app-menu': AdminMenu,
    'admin-list-component': AdminListComponent
  },
  methods: {
    getName: function (director) {
      return this.$options.filters.translation(director.name);
    }
  }
}
</script>

<style scoped>
#directors {
  background-color: white;
  min-height: 100vh;
  overflow: hidden;
}
</style>
